<div class="flex flex-col p-4">
  <div class="flex flex-row items-center">
    <mat-form-field class="permit-select">
      <mat-label>Languages</mat-label>
      <mat-select
        [(ngModel)]="selectedLanguage"
        name="languages"
        (selectionChange)="onSelectionChange($event)"
      >
        <mat-option
          *ngFor="let language of languages"
          [value]="language"
        >
          {{ language.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button
      [tp]="translateBasePath + '.Tooltip.Initialize' | translate"
      tpPlacement="right"
      mat-icon-button
      (click)="initializeTranslations()"
    >
      <mat-icon>psychology</mat-icon>
    </button>
  </div>

  <div class="flex flex-row h-full">
    <mat-tab-group
      class="w-full"
      mat-stretch-tabs="false"
    >
      <mat-tab label="Translations">
        <app-data-grid
          [rows]="translations"
          [useCRUDEvents]="true"
          [canEdit]="true"
          [canCreate]="true"
          [canDelete]="true"
          [CRUDConfig]="settingCRUD"
          [columns]="columns"
          [autoColumn]="false"
          [pageSize]="18"
          [loading]="translations.length === 0 && isLoading"
          (editSaved)="editRow($event)"
          (createSaved)="createRow($event)"
          (deleteClicked)="deleteRow($event)"
        ></app-data-grid>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
